// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"83f67b5b","122":"04bef7b4","162":"7184fe26","311":"359f0f15","354":"a3798949","390":"2e81155b","447":"5ba5b475","573":"907b6e63","605":"b0625e66","692":"da8e3057","787":"ac4f8549","844":"48cf254f","880":"40bfbbe8","883":"50f8800e","937":"c51463b4","991":"85113040"}[chunkId] + ".chunk.js";
};